var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FontAwesomeIcon',{style:(_vm.styles),attrs:{"icon":_vm.customType,"mask":_vm.mask,"transform":_vm.transform,"spin":_vm.spin,"pulse":_vm.pulse,"border":_vm.border},on:{"click":_vm.click}})}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/icon/faicon.vue